// Action Constants

export enum ActionConstant {
	GET_ORG_DETAILS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_ORG_DETAILS',
	CLEAR_ORG_DETAILS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/CLEAR_ORG_DETAILS',
	GET_PLAN_LIST = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_PLAN_LIST',
	CLEAR_PLAN_LIST = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/CLEAR_PLAN_LIST',
	GET_PLAN_DETAILS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_PLAN_DETAILS',
	CLEAR_PLAN_DETAILS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/CLEAR_PLAN_DETAILS',
	GET_STATUS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_STATUS',
	CLEAR_STATUS = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/CLEAR_STATUS',
	GET_ORG_DETAILS_FAILED = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_ORG_DETAILS_FAILED',
	GET_PLAN_LIST_FAILED = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_PLAN_LIST_FAILED',
	GET_PLAN_DETAILS_FAILED = 'FILE://ENTERPRISE_PLAN_MANAGEMENT/GET_PLAN_DETAILS_FAILED',
}

export interface OrgLists {
	type: ActionConstant.GET_ORG_DETAILS;
	rows: [];
}

export interface Lists {
	type: ActionConstant.GET_PLAN_LIST;
	count: number;
	rows: [];
}
export interface Plan {
	id: number;
	name: string;
	documentCount: number;
	documentSize: number;
	scanCount: number;
	projectCount: number;
	tradeCount: number;
	userCount: number;
	duration: number;
	durationUnit: number;
	amount: number;
	order: number;
}

export interface GetOrgListType {
	type: ActionConstant.GET_ORG_DETAILS;
	data: OrgLists;
}
export interface GetListType {
	type: ActionConstant.GET_PLAN_LIST;
	data: Lists;
}
export interface GetPlanType {
	type: ActionConstant.GET_PLAN_DETAILS;
	data: Plan;
}

export interface ClearOrgListType {
	type: ActionConstant.CLEAR_ORG_DETAILS;
}
export interface ClearListType {
	type: ActionConstant.CLEAR_PLAN_LIST;
}
export interface ClearPlanType {
	type: ActionConstant.CLEAR_PLAN_DETAILS;
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}
export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface GetOrgListFailedType {
	type: ActionConstant.GET_ORG_DETAILS_FAILED;
}
export interface GetListFailedType {
	type: ActionConstant.GET_PLAN_LIST_FAILED;
}
export interface GetPlanDetailsFailedType {
	type: ActionConstant.GET_PLAN_DETAILS_FAILED;
}

export type ActionType =
	| GetOrgListType
	| ClearOrgListType
	| GetListType
	| ClearListType
	| GetStatusType
	| ClearStatusType
	| GetPlanType
	| ClearPlanType
	| GetOrgListFailedType
	| GetListFailedType
	| GetPlanDetailsFailedType;

export interface InitialState {
	orglistFetching: boolean;
	orglist: [];
	listFetching: boolean;
	list: [];
	plan: any;
	detailsFetching: boolean;
	statusCode: number;
}
